import React from "react";
import Modal from "../../../components/Modal/Modal";
import { TitleModalFilter } from "../style";
import styled from "styled-components";
import { MyButton } from "../../../components/Button/style";
import { useApp } from "../../../contexts";
import { Space } from "antd";
import { useWindowSize } from "../../../hook/useWindowSize";
import { deviceDetect } from "react-device-detect";
import { splitAddressWallet } from "../../../utils/hepler";
import { verifyWeb3OwnerProof } from "../../../services/app";
import { ethers } from "ethers";

const ModalContainer = styled(Modal.Container)`
  padding: 48px 64px;
  width: 550px;
  background: #f5f5f5;
  @media (max-width: 640px) {
    width: 335px;
    padding: 24px;
  }
`;

const ModalTitle = styled(TitleModalFilter)`
  color: #000;
  @media (max-width: 640px) {
    font-size: 22px;
  }
  &.connected {
    color: #f12e11;
  }
`;

const TextWrapper = styled.div`
  background: #e9e9e9;
  padding: 16px;
  border-radius: 10px;
`;

const ModalVerifyWallet = ({ web3OwnerProof, onClose, onVerified }) => {
  const size = useWindowSize();
  const isMobile = size.width < 1024;
  const { isBrowser } = deviceDetect();
  const { T, setAlert } = useApp();

  const continueMetaMask = async () => {
    try {
      const signature = await window.ethereum.request({
        method: "personal_sign",
        params: [
          // The message needs to be a hex string for some Ethereum providers
          ethers.utils.hexlify(ethers.utils.toUtf8Bytes(web3OwnerProof.token)),
          web3OwnerProof.address,
        ],
      });
      if (signature) {
        const verifyRes = await verifyWeb3OwnerProof(web3OwnerProof.address, signature);
        if (verifyRes) {
          if (typeof onVerified === "function") {
            onVerified(web3OwnerProof.address);
          }
        }
      }
    } catch (error) {
      console.log(error);
      if (isBrowser) {
        document.querySelector("#metamask-link")?.click();
        return;
      }
      setAlert({
        type: "error",
        text: T("please install MetaMask extension."),
      });
    }
  };

  return (
    <Modal>
      <Modal.ModalBg onClick={onClose} />
      <ModalContainer onClose={onClose}>
        <ModalTitle>{T("web3WalletVerifyTitle")}</ModalTitle>
        <div className="mt-[15px] sm:mt-[30px] flex flex-col w-full">
          <div className="mb-4">
            {T(
              "We need to verify you own your wallet by asking you to sign a simple message in MetaMask. This is completely secure and doesn't cost any gas fees."
            )}
          </div>
          <TextWrapper className="mb-4">
            <div className="font-bold">{T("What will happen next:")}</div>
            <div className="pl-2" dangerouslySetInnerHTML={{ __html: T("What will happen next desc") }} ></div>
          </TextWrapper>
          <div className="mb-4">{T("Your wallet address")}:</div>
          <TextWrapper>
            {isMobile
              ? splitAddressWallet(web3OwnerProof.address, 10, 10)
              : web3OwnerProof.address}
          </TextWrapper>
          <div className="flex flex-col lg:flex-row gap-4 mt-8">
            <MyButton className="grow" onClick={onClose}>
              {T("Cancel")}
            </MyButton>
            <MyButton className="primary grow" onClick={continueMetaMask}>
              {T("Continue to MetaMask")}
            </MyButton>
          </div>
        </div>
      </ModalContainer>
    </Modal>
  );
};

export default ModalVerifyWallet;
